<template>
    <b-modal
        :no-close-on-backdrop="true"
        id="modal-order-approval-log"
        modal-class="modals-approval modals-approval-dashboard gofixModal"
        size="lg"
        title="Approval"
        hide-footer
        :centered="true"
        ref="modal-approval-log"
        v-model="modals.approval_log"
        @hidden="approvalLogObj.remark = null">
        <!-- Action & Remarks -->
        <div class="actionAndRemarks modalPadding" v-bind:class="{'disabled-block':!approvalData.approval}">
            <b-row>
                <b-col md="12" class="mb-3" v-if="Item && (Item.order_status === 'Under Approval' || Item.order_status === 'Issued' || Item.order_status === 'Pending Revision')">
                    <gofix-text-field label="Next Approver" oneline>
                        <span class="pl-20" v-if="approvalData.limit && checkInRoleApproval()">--</span>
                        <span class="pl-20" v-else>{{approverNext.limit| formatMoney}} - {{approverNext.user}}</span>
                    </gofix-text-field>
                </b-col>
                <b-col md="12" class="mb-3" v-if="Item && (Item.order_status === 'Under Approval' || Item.order_status === 'Issued' || Item.order_status === 'Pending Revision')">
                    <gofix-text-field label="Current Approver" oneline>
                        <span v-if="Item && Item.order_status === 'Issued'">--</span>
                        <span v-else>{{approverCurrent.limit| formatMoney}} - {{approverCurrent.user ? approverCurrent.user : ''}}</span>
                    </gofix-text-field>
                </b-col>
                <b-col md="9" class="">
                    <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="approvalLogObj.remark" />
                </b-col>
                <b-col md="3" class="action">
                    <gofix-button
                        class="d-block mb-2 w-100"
                        :label="Item && Item.order_status === 'Pending Revision' ? 'Revision Applied' : (Item && Item.order_status === 'Issued' ? 'Request for Approval' : 'Recommend for Approval')"
                        @click="approvalLog('Recommend for Approval')"
                        v-if="!approvalData.limit"
                        :disabled="(!approvalData.approval) || loadings.logs"
                        outline />
                    <gofix-button
                        class="d-block mb-2 w-100"
                        label="Approve"
                        @click="approvalLog('Approval')"
                        v-if="approvalData.limit"
                        :disabled="!approvalData.approval || loadings.logs"
                        outline />
                    <gofix-button
                        class="d-block mb-2 w-100"
                        label="Request for Revision"
                        @click="approvalLog('Request for Revision')"
                        v-if="(Item && Item.current_approval_level >= 0 && Item.current_approval_level !== null)"
                        :disabled="!approvalData.approval || loadings.logs"
                        outline />
                    <gofix-button
                        v-if="Item && Item.order_status !== 'Issued'"
                        class="d-block w-100"
                        label="Reject"
                        @click="approvalLog('Reject')"
                        :disabled="!approvalData.approval || loadings.logs"
                        outline dark />
                    <gofix-button
                        v-if="Item && Item.order_status === 'Issued'"
                        class="d-block w-100"
                        label="Cancel"
                        @click="modals.approval_log = false"
                        outline dark />
                </b-col>
            </b-row>
        </div>
        <hr/>
        <b-row>
            <b-col md="12" class="mb-3">
                <h5 class="modalTitle modalPadding">Approval Log</h5>
            </b-col>
            <b-col md="12">
                <div class="gofixBasicTable approvalLogTable">
                    <div class="dataList">
                        <vue-scrollbar class="tableList">
                            <b-table :fields="fields" :items="ApprovalLogs.data" class="table-has-fixed" fixed>
                                <template slot="finance_limit" slot-scope="row">
                                    {{ row.item.finance_limit | formatMoney}}
                                </template>
                                <template slot="log_time" slot-scope="row">
                                    {{ row.item.log_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                                </template>
                            </b-table>
                        </vue-scrollbar>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'modal-approval-order',
        data () {
            return {
                id: null,
                approvalLogObj:{
                    order_id : null,
                    approval_id: null,
                    action:null,
                    remark:null,
                    approval: false,
                    reject: false,
                },
                approvalData:{
                    current:null,
                    limit:false,
                    approval: false
                },
                approverCurrent: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                approverNext: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                fields:[
                    {
                        key: 'approval_route_level',
                        label: 'Level',
                        thStyle: 'width: auto'
                    },
                    {
                        key: 'finance_limit',
                        label: 'Approval Limit',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'reviewer.name',
                        label: 'Reviewer',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'log_time',
                        label: 'Date Time',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'action',
                        thStyle: 'width: 170px',
                        label: 'Action',
                    },
                    {
                        key: 'remark',
                        thStyle: 'width: 170px',
                        label: 'Remarks',
                    },
                ],
                modals: {
                    approval_log: false
                },
                loadings : {
                    logs: false
                },
            };
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                ApprovalLogs: 'OrderApprovalLogController/Items',
                User : 'AuthController/user',
            }),
        },
        watch: {
            "Item": function(val){
                if(val && val.id == this.id) {
                    this.openModalApproval();
                }
            }
        },
        methods: {
            getData(id) {
                if(id) {
                    this.id = id;
                    this.approvalLogObj.order_id = id;
                    this.getItem();
                    this.getApprovalLogs();
                }
            },
            openModalApproval(){
                if(this.Item.get_order_line_item.length){
                    //check limit again
                    this.getNextApprover();
                    this.checkApprovalAccess(this.Item)
                    this.modals.approval_log = true
                }else{
                    this.$alertNotification("Please add a order line item to approve", "warning");
                }
            },
            getItem() {
                this.$store.dispatch("OrderController/getItem", this.id)
                .then(data => {
                    if(data.order_status === 'Under Approval' || data.order_status === 'Issued'){
                        this.getNextApprover();
                    }
                })
                .catch(err=>{
                    return this.$router.push(`/v2/orders`);
                });
            },
            getApprovalLogTableSetting(){
                this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                    user_id: 0,
                    table_name: "work-order-approval-log"
                }).then(response => {
                    this.fields = response.data.data.settings.fields
                }).catch(error => {})
            },
            getApprovalLogs() {
                this.loadings.logs = true;
                this.$store.dispatch("OrderApprovalLogController/getItems",{
                    page:1,
                    limit:-1,
                    filter:{
                        order_id: this.id
                    }
                })
                    .then( data => {
                        this.loadings.logs = false;
                    })
                    .catch(err => {
                        this.loadings.logs = false;
                    })
            },
            checkApprovalAccess(val){
                let key = (val.current_approval_level >= 0 && val.current_approval_level !== null) ? val.current_approval_level : 0;
                this.approvalData.current = this.Item.approval_levels[key] ? this.Item.approval_levels[key] : null;
                if(this.approvalData.current && (this.Item.order_status === "Under Approval" || (this.Item.order_status === "Pending Revision" && val.current_approval_level >= 0))){
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    if(this.approvalData.current && this.approvalData.current.finance_limit >= this.Item.total_net_amount){
                        this.approvalData.limit = true;
                    }else{
                        this.approvalData.limit = false;
                    }
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                        this.approvalData.approval = true;
                    }else{
                        this.approvalData.approval = false;
                    }
                }else if(this.approvalData.current && (this.Item.order_status === "Pending Revision" && val.current_approval_level === -1)){
                    this.approvalData.approval = true;
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                        if(this.approvalData.current && this.approvalData.current.finance_limit >= this.Item.total_net_amount){
                            this.approvalData.limit = true;
                        }else{
                            this.approvalData.limit = false;
                        }
                    }
                }else{
                    this.approvalData.approval = false;
                    this.approvalData.limit = false;
                }
            },
            checkInRoleApproval(){
                if(!this.approvalData.current || !this.approvalData.current.roles) return false;
                let userRoles = this.User.roles.map(a => a.id);
                let roles     = this.approvalData.current.roles.map(a => a.id);
                const arrTmp  = userRoles.filter(item => roles.includes(item));
                if(arrTmp.length){
                    return true;
                }
                return false
            },
            approvalLog(action){
                if (!this.approvalData.approval) return;
                if(this.loadings.logs) return;
                this.loadings.logs = true;
                let userRoles = this.User.roles.map(a => a.id);
                this.approvalLogObj.action = action;
                if(action === "Reject") this.approvalLogObj.reject = true;
                if(action === "Approval")this.approvalLogObj.approval = true;
                this.$store.dispatch("OrderApprovalLogController/createItem",this.approvalLogObj)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('adding', 'approval'));
                        this.modals.approval_log = false;
                        if(this.approvalLogObj.reject) this.Item.order_status = "Rejected";
                        if(this.approvalLogObj.approval) this.Item.order_status = "Approved";
                        this.getNextApprover();
                    })
                    .catch( err => {
                        this.$alertNotification(`Can't "${action}"`, "warning");
                        setTimeout(()=>{
                            this.loadings.logs = false;
                        },1000);
                    })
            },
            getNextApprover(){
                this.$store.dispatch("OrderApprovalLogController/getNextApprover",{
                    order_id: this.id,
                })
                    .then(response => {
                        this.approverNext.user = response.next.user_name ? response.next.user_name.join(", ") : null;
                        this.approverNext.ids = response.next.user_ids;
                        this.approverNext.limit = response.next.finance;

                        this.approverCurrent.user = response.current.user_name ? response.current.user_name.join(", ") : null;
                        this.approverCurrent.ids = response.current.user_ids;
                        this.approverCurrent.limit = response.current.finance;
                    })
                    .catch( err => {
                        this.approverNext.user = null;
                        this.approverNext.ids = [];
                        this.approverNext.limit = null;

                        this.approverCurrent.user = null;
                        this.approverCurrent.ids = [];
                        this.approverCurrent.limit = null;
                    })
            },
        }
    }
</script>